import React, { useEffect } from "react";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import { withStyles } from "@material-ui/core/styles";
import { withStore } from "store/storeHandler";
import Typography from "@material-ui/core/Typography";
import { makeRandomText } from "lib/commonUtil";
import { getDeviceType, isIOS, isAndroid } from "lib/deviceInfo";
import { sleep } from "lib/commonUtil";
import kakaoPayIcon from "img/kakaopay_icon_small.png";
import GaHelper from "lib/gaHelper";
import config from "lib/fr-config";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

const ROOT_URL = config.rootURL;

const SubInfoTypography = withStyles({
  root: {
    maxWidth: 260,
    fontSize: 12,
    paddingTop: 10,
    display: "flex",
    justifyContent: "center",
    wordBreak: "keep-all",
    textAlign: "center"
  }
})(Typography);

KorSubscribeBtnView.propTypes = {
  priceInfo: PropTypes.shape({
    originalPrice: PropTypes.object.isRequired,
    discountedPrice: PropTypes.object,
    paypalPlanId: PropTypes.string,
    saleEndDate: PropTypes.string,
    validUntil: PropTypes.string.isRequired
  }).isRequired,
  onSubscribeViaPortone: PropTypes.func.isRequired,
  isLatestMembershipInfo: PropTypes.func.isRequired,
  catchPortonePaymentError: PropTypes.func.isRequired,
  resetButtonType: PropTypes.func.isRequired
};

function KorSubscribeBtnView(props) {
  const {
    priceInfo,
    onSubscribeViaPortone,
    isLatestMembershipInfo,
    catchPortonePaymentError,
    resetButtonType,
    username,
    email,
    AppErrorActions
  } = props;

  useEffect(() => {
    init();
  }, []);

  const IMP = window.IMP;

  const init = () => {
    IMP.init("imp06019379");

    sendGAEvent("buttonInit");
  };

  const sendGAEvent = eventType => {
    switch (eventType) {
      case "buttonInit":
        GaHelper.setGAEvent({
          type: "ma_view_membership_start_btn"
        });
        return null;
      case "buttonClick":
        GaHelper.setGAClickEvent({ type: "membershipStartBtn" });
        return null;

      default:
        console.error(`wrong eventType : "${eventType}"`);
        return null;
    }
  };

  const getPriceKRW = () => {
    const { originalPrice, discountedPrice } = priceInfo;
    const priceObj = discountedPrice || originalPrice;
    return priceObj.kr_won;
  };

  const getReqParamObj = ({ pgType }) => {
    let pg;
    switch (pgType) {
      case "kakaopay":
        pg = "kakaopay.CARMVHJOKX";
        // pg = "kakaopay"; // 테스트 연동
        break;
      case "kcp":
        pg = "kcp_billing.IP230";
        // pg = "kcp_billing.BA001"; // 테스트 연동
        break;
      case "inicis":
        pg = "html5_inicis.MOImaunent";
        // pg = "html5_inicis.INIBillTst"; // 테스트 연동
        break;
      default:
        const errObj = Error(`wrong pgType`);
        errObj.errorValue = { pgType };
        AppErrorActions.setSafeAppError(errObj);
        break;
    }

    return {
      pg,
      pay_method: "card",
      merchant_uid: getMUID(),
      name: "Maunent Creative 정기결제",
      amount: getPriceKRW(),
      currency: "KRW",
      customer_uid: getCUID(),
      /** 하단 email 필수, 없으면 결제사용자 식별 불가. */
      buyer_email: email,
      buyer_name: username,
      digital: true,
      m_redirect_url: `${ROOT_URL}${getEssentialUrl({ type: "membership" })()}`
    };
  };

  const getCreditCardPg = () => {
    /**
     * 221226 기준
     * 데스크탑 : 원래 kcp는 공인인증서 요구하지 않았지만, 어느순간 요구.
     * ios : kcp, 카카오페이 결제창 상단에 주소표시되지만 사용성 측면에선 이상없음.
     * 안드로이드 : kcp, 카카오페이 결제창 상단에 주소표시되며, 사용자가 이를 클릭시 주소가 계속 남게되어 사용성 떨어짐.
     */
    /**
     * 250701(대략)기준
     * 결제 하도 안해서 kcp는 중단되었다.
     * 그러므로 kcp는 pg선정 단계에서 임시 배제.
     */
    if (getDeviceType() === "desktop") return "inicis"; //원래 kcp
    else if (isIOS) return "inicis"; //원래 kcp
    else if (isAndroid) return "inicis";
    else return "inicis";
  };

  const getCUID = () => {
    const LENGTH_OF_CUID = 30;

    const nowUTCTimestamp = String(new Date().getTime());

    let prefix = `c${nowUTCTimestamp}_`;

    const randomTextLength = LENGTH_OF_CUID - prefix.length;

    const uid = `${prefix}${makeRandomText("little", randomTextLength)}`;

    return uid;
  };

  const getMUID = () => {
    const nowUTCDateStr = new Date().toISOString();

    const yy = nowUTCDateStr.substring(2, 4);
    const mm = nowUTCDateStr.substring(5, 7);
    const dd = nowUTCDateStr.substring(8, 10);

    const hours = nowUTCDateStr.substring(11, 13);
    const minutes = nowUTCDateStr.substring(14, 16);
    const seconds = nowUTCDateStr.substring(17, 19);

    const nowDate = `${yy}${mm}${dd}`;
    const nowTime = `${hours}${minutes}${seconds}`;

    let prefix = "min";

    const uid = `${prefix}${nowDate}${nowTime}_${makeRandomText("little", 8)}`;

    return uid;
  };

  const displayPortoneWindow = async ({ pgType }) => {
    const paramObj = getReqParamObj({ pgType });

    IMP.request_pay(paramObj, async rsp => {
      if (rsp.success) {
        // const { imp_uid, merchant_uid } = rsp;
        await onSubscribeViaPortone();
      } else {
        const { error_code } = rsp;
        if (error_code === "F1002") {
          /**
           * merchant_uid가 중복되면 하단 코드에서 에러 표시하지만,
           * customer_uid는 중복되어도 결제가 진행되어 백엔드에서 충돌이 발생된다.
           */
          /** 사용된 merchant_uid가 이미 사용중인 경우 */
          const errObj = Error(`same merchant_uid exist`);
          errObj.errorValue = { merchant_uid: paramObj.merchant_uid };
          AppErrorActions.setSafeAppError(errObj);
          await sleep(500);
          await displayPortoneWindow({ pgType });
        } else {
          const { error_msg, imp_uid } = rsp;
          catchPortonePaymentError({ error_msg, imp_uid });
        }
      }
    });
  };

  const handleCreditCardBtnClick = async () => {
    if (!(await isLatestMembershipInfo())) {
      resetButtonType();
      return null;
    }
    const pgType = getCreditCardPg();
    await displayPortoneWindow({ pgType });

    sendGAEvent("buttonClick");
  };

  const handleKakaoPayBtnClick = async () => {
    if (!(await isLatestMembershipInfo())) {
      resetButtonType();
      return null;
    }
    await displayPortoneWindow({ pgType: "kakaopay" });

    sendGAEvent("buttonClick");
  };

  return (
    <div>
      <div style={{ paddingBottom: 10 }}>
        <ContainedCommonButtonView
          fullWidth
          design={"soft"}
          onClick={handleKakaoPayBtnClick}
        >
          <span style={{ display: "flex", alignItems: "center" }}>
            <img
              alt=""
              src={kakaoPayIcon}
              style={{
                height: 18,
                paddingRight: 5
              }}
            />
            <span>카카오페이</span>
          </span>
        </ContainedCommonButtonView>
      </div>
      <div style={{ paddingBottom: 10 }}>
        <ContainedCommonButtonView
          fullWidth
          design={"soft"}
          onClick={handleCreditCardBtnClick}
        >
          신용카드
        </ContainedCommonButtonView>
      </div>
      {getDeviceType() === "desktop" && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <SubInfoTypography>
            PC 환경에서의 신용카드 결제 시도시 공인인증서가 필요할 수 있으며,
            모바일에서의 결제를 권장합니다.
          </SubInfoTypography>
        </div>
      )}
      {/** <SubInfoTypography>결제 완료 즉시 이용 가능합니다.</SubInfoTypography> */}
    </div>
  );
}

export default withStore({
  stateMap: { myAccount: ["username", "email"] },
  dispatchMap: ["appError"]
})(KorSubscribeBtnView);
